// Выбор генератора документов (болванки) по текущей базе
import * as doc88 from './doc'
import * as docNovaya from './doc-novaya'

const registry = {
    nevskiy88: doc88,
    novaya: docNovaya
}

export function getDocModule() {
    const base = localStorage.getItem('baseName')
    return registry[base] || doc88
}